(function () {
  'use strict';

  var TEST_ID = 'MC_PDP_SCARCITYMODULE_HISTRIPS';
  var REVIEW_THEME_NAME = 'ab/MC_PDP_SCARCITYMODULE_HISTRIPS';
  var theme = window.comaison && window.comaison.theme;
  var params = new URLSearchParams(window.location.search);
  var arm = params.get('maison_ab_arm');

  if (
    theme && theme.role === 'unpublished' && theme.name === REVIEW_THEME_NAME &&
    params.get('maison_ab_preview') === TEST_ID && (arm === 'control' || arm === 'variation')
  ) {
    document.documentElement.setAttribute('data-onyx-scarcity-review', arm);
  }

  if (customElements.get('onyx-scarcity')) return;

  class OnyxScarcity extends HTMLElement {
    connectedCallback() {
      if (this._observer) return;

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-revealed');
        return;
      }

      this._observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.classList.add('is-revealed');
        this._observer.disconnect();
        this._observer = null;
      }, { threshold: 0.2 });
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (!this._observer) return;
      this._observer.disconnect();
      this._observer = null;
    }
  }

  customElements.define('onyx-scarcity', OnyxScarcity);
})();
